var map = {
	"./ca/main.yml": 32,
	"./cy/main.yml": 33,
	"./de/main.yml": 34,
	"./en/main.yml": 35,
	"./es/main.yml": 36,
	"./eu/main.yml": 37,
	"./fr/main.yml": 38,
	"./hr/main.yml": 39,
	"./it/main.yml": 40,
	"./oc/main.yml": 41,
	"./pl/main.yml": 42
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 157;